import { Link, Outlet } from "react-router-dom";
import { SleuthMark } from "./SleuthMark";

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function Header() {
  return (
    <header className="border-b border-[var(--color-border-soft)]">
      <div className="mx-auto max-w-5xl px-6 h-14 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5 text-[var(--color-text-strong)] hover:!text-[var(--color-text-strong)]"
        >
          <SleuthMark className="w-7 h-7" />
          <span className="font-semibold">LagSleuth</span>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          <Link to="/privacy" className="text-[var(--color-text-muted)] hover:!text-[var(--color-text)]">
            Privacy
          </Link>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="border-t border-[var(--color-border-soft)] mt-24">
      <div className="mx-auto max-w-5xl px-6 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-[var(--color-text-dim)]">
        <div className="flex items-center gap-2">
          <SleuthMark className="w-4 h-4 opacity-70" />
          <span>LagSleuth · LatentLab</span>
        </div>
        <div className="flex items-center gap-5">
          <Link to="/privacy" className="text-[var(--color-text-muted)] hover:!text-[var(--color-text)]">
            Privacy
          </Link>
          <a
            href="https://github.com/CallMeCCLemon/LagSleuth"
            className="text-[var(--color-text-muted)] hover:!text-[var(--color-text)]"
            rel="noreferrer noopener"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
}
